// Zeiträume für die EFFIS-Karten
const effisNow = new Date();
const effisToday = effisNow.toISOString().slice(0, 10);

const effisWeekStart = new Date(
  effisNow.getTime() - 6 * 24 * 60 * 60 * 1000
).toISOString().slice(0, 10);

const effisWeek = `${effisWeekStart}/${effisToday}`;
const effisYear = `${effisToday.slice(0, 4)}-01-01/${effisToday}`;

export const externalLayers = [
    {
      id: 'bebb_bdom_wms',
      dct_type: 'raster',
      dct_title: 'WMS BB-BE BDOM 1m Cache',
      url: 'https://isk.geobasis-bb.de/mapproxy/bdom/service/wms',
      legend_url: "https://isk.geobasis-bb.de/mapproxy/bdom/service/wms?format=image%2Fpng&layer=bebb_bdom&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=",
      layer: 'bebb_bdom',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'GeoBasis BB-BE',
      metadata: "https://isk.geobasis-bb.de/mapproxy/bdom/service/wms?REQUEST=GetCapabilities&SERVICE=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Landesvermessung und Geobasisinformation Brandenburg (LGB)",
    },
    {
      id: 'dgm_wms',
      dct_type: 'raster',
      dct_title: 'WMS BB-BE DGM 1m Cache',
      url: 'https://isk.geobasis-bb.de/mapproxy/dgm/service/wms',
      legend_url: "https://isk.geobasis-bb.de/mapproxy/dgm/service/wms?format=image%2Fpng&layer=dgm&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=",
      layer: 'dgm',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'GeoBasis BB-BE',
      metadata: "https://isk.geobasis-bb.de/mapproxy/dgm/service/wms?REQUEST=GetCapabilities&SERVICE=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Landesvermessung und Geobasisinformation Brandenburg (LGB)",
    },
    {
      id: 'Orthophoto_wms',
      dct_type: 'raster',
      dct_title: 'Digitale Orthophoto',
      url: 'https://isk.geobasis-bb.de/ows/sentinel2_wms',
      layer: 's2_mai24',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'GeoBasis BB-BE',
      metadata: "https://isk.geobasis-bb.de/mapproxy/dgm/service/wms?REQUEST=GetCapabilities&SERVICE=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Landesvermessung und Geobasisinformation Brandenburg (LGB)",
    },
    {
      id: 'Landcover_wms_inspire',
      dct_type: 'raster',
      dct_title: 'CORINE Land Cover – 5ha (2018)',
      url: 'https://sgx.geodatenzentrum.de/wms_clc5_2018',
      legend_url:"https://sgx.geodatenzentrum.de/wms_clc5_2018?format=image/png&layer=clc5&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=&",
      layer: 'clc5',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      metadata: "https://mis.bkg.bund.de/csw?REQUEST=GetRecordById&SERVICE=CSW&VERSION=2.0.2&elementSetName=full&id=206F9836-0493-4E76-872A-33F4A723A321",
      geometry_type: 'raster',
      dct_catalog_publisher:"Bundesamt für Kartographie und Geodäsie (BKG)",
    },
    {
      id: 'solaratlas_solarbericht_energieportal_brandenburg_wms',
      dct_type: 'raster',
      dct_title: 'Statistiken Potenzialanalyse Dach- und Freiflächen für Photovoltaik',
      url: 'https://energieportal-brandenburg.de/geoserver/solaratlas/ows',
      legend_url: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=solaratlas_solarbericht&",
      layer: 'solaratlas_solarbericht',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Energieportal Brandenburg',
      metadata: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?request=GetCapabilities&service=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Energieportal Brandenburg",
      dct_catalog_title:"Statistiken Potenzialanalyse Dach- und Freiflächen für Photovoltaik",
      dct_description: "Der Dienst beinhaltet die Ergebnisse der Potenzialanalyse über nutzbare Flächen für solartechnische Anlagen im Land Brandenburg. Es werden alle umsetzbaren Potenziale als Statistiken auf Ebene der Gemeinden, Ämter, Landkreise, Regionen und Land aufgezeigt. Neben den Dachflächen werden die für Freiflächenanlagen geeigneten EEG-Basisflächen gezeigt, d.h. die Flächen, die nach dem Erneuerbaren-Energien-Gesetz für PV-Freiflächenanlagen genutzt werden sollen und bei denen keine übergeordneten naturschutzrechtlichen oder landesplanerischen Belange entgegenstehen. Ebenso werden die Potenziale für PV-Freiflächenanlagen außerhalb der EEG-förderfähigen Flächenkulisse dargestellt.",
    },
    {
      id: 'solaratlas_dachflaecheneignung_energieportal_brandenburg_wms',
      dct_type: 'raster',
      dct_title: 'Eignung der Dachflächen für Photovoltaikanlagen',
      url: 'https://energieportal-brandenburg.de/geoserver/solaratlas/ows',
      legend_url: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=solaratlas_dachflaecheneignung&",
      layer: 'solaratlas_dachflaecheneignung',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Energieportal Brandenburg',
      metadata: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?request=GetCapabilities&service=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Energieportal Brandenburg",
      dct_catalog_title:"Statistiken Potenzialanalyse Dach- und Freiflächen für Photovoltaik",
      dct_description: "Der Web Map Service des Energieportals zeigt die Potenziale für Photovoltaik auf Dach-und Freiflächen. Außerdem werden Energieerzeugungsanlagen thematisiert."

    },
    {
      id: 'solaratlas_verschattung_energieportal_brandenburg_wms',
      dct_type: 'raster',
      dct_title: 'Verschattungsanalyse der Dachflächen für Photovoltaikanlagen',
      url: 'https://energieportal-brandenburg.de/geoserver/solaratlas/ows',
      legend_url: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=solaratlas_verschattung&",
      layer: 'solaratlas_verschattung',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Energieportal Brandenburg',
      metadata: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?request=GetCapabilities&service=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Energieportal Brandenburg",
      dct_catalog_title:"Verschattungsanalyse der Dachflächen für Photovoltaikanlagen",
      dct_description: "Der Darstellungsdienst beinhaltet die Ergebnisse der Potenzialanalyse über nutzbare Flächen für solartechnische Anlagen im Land Brandenburg (im Auftrag des Ministeriums für Wirtschaft, Arbeit und Energie des Landes Brandenburg). Es werden alle umsetzbaren Potenziale von einzelnen Gebäuden als Verschattungsanalyse dargestellt."
    },
    {
      id: 'solaratlas_potenzial_photovoltaik_freiflaechen_energieportal_brandenburg_wms',
      dct_type: 'raster',
      dct_title: 'Eignung der Freiflächen für Photovoltaikanlagen nach EEG 2023',
      url: 'https://energieportal-brandenburg.de/geoserver/solaratlas/ows',
      legend_url: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=solaratlas_potenzial_photovoltaik_freiflaechen&",
      layer: 'solaratlas_potenzial_photovoltaik_freiflaechen',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Energieportal Brandenburg',
      metadata: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?request=GetCapabilities&service=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Energieportal Brandenburg",
      dct_catalog_title:"Eignung der Freiflächen für Photovoltaikanlagen nach EEG 2023",
      dct_description: "Der Darstellungsdienst beinhaltet die Ergebnisse der Potenzialanalyse über nutzbare Flächen für solartechnische Anlagen im Land Brandenburg. Es werden die für Photovoltaik-Freiflächenanlagen geeigneten EEG-Basisflächen gezeigt, d.h. die Flächen, die nach dem Erneuerbaren-Energien-Gesetz für Freiflächenanlagen genutzt werden sollen und bei denen keine übergeordneten naturschutzrechtlichen oder landesplanerischen Belange entgegenstehen. Weiter werden die Potenziale für Photovoltaik-Freiflächenanlagen (Agri-Photovoltaikanlagen) außerhalb der EEG-förderfähigen Flächenkulisse dargestellt."
    },
    {
      id: 'solaratlas_potenzial_photovoltaik_landwirtschaft_energieportal_brandenburg_wms',
      dct_type: 'raster',
      dct_title: 'Eignung der Freiflächen für Agri-Photovoltaikanlagen',
      url: 'https://energieportal-brandenburg.de/geoserver/solaratlas/ows',
      legend_url: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=solaratlas_potenzial_photovoltaik_landwirtschaft&",
      layer: 'solaratlas_potenzial_photovoltaik_landwirtschaft',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Energieportal Brandenburg',
      metadata: "https://energieportal-brandenburg.de/geoserver/solaratlas/ows?request=GetCapabilities&service=WMS",
      geometry_type: 'raster',
      dct_catalog_publisher:"Energieportal Brandenburg",
      dct_catalog_title:"Eignung der Freiflächen für Agri-Photovoltaikanlagen",
      dct_description: "Der Darstellungsdienst beinhaltet die Ergebnisse der Potenzialanalyse über nutzbare Flächen für solartechnische Anlagen im Land Brandenburg. Es werden die für Photovoltaik-Freiflächenanlagen geeigneten EEG-Basisflächen gezeigt, d.h. die Flächen, die nach dem Erneuerbaren-Energien-Gesetz für Freiflächenanlagen genutzt werden sollen und bei denen keine übergeordneten naturschutzrechtlichen oder landesplanerischen Belange entgegenstehen. Weiter werden die Potenziale für Photovoltaik-Freiflächenanlagen (Agri-Photovoltaikanlagen) außerhalb der EEG-förderfähigen Flächenkulisse dargestellt."
    },
    
    {
      id: 'gewaessernetz_route_wms',
      dct_type: 'raster',
      dct_title: 'Gewässernetz mit Kilometrierung im Land Brandenburg – Route',
      url: 'https://maps.brandenburg.de/services/wms/gewnet',
      legend_url: "https://maps.brandenburg.de/WMS/wasser/gewnet/legenden/gewnet25_bb.png",
      layer: 'Gewaessernetz_Route',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'GeoBasis',
      metadata: "https://geoportal.brandenburg.de/gs-json/xml?fileid=B9D461F1-99A1-4C10-97B4-9C36C0BD40B9",
      geometry_type: 'raster',
      dct_catalog_publisher:"Landesvermessung und Geobasisinformation Brandenburg (LGB)",
      dct_catalog_title:"Gewässernetz mit Kilometrierung im Land Brandenburg",
      dct_description: "Darstellungsdienst Gewässernetz Version 4.4.1 mit Kilometrierung im Land Brandenburg. Bitte beachten Sie die Links zu den Nutzungsbedingungen (siehe AccessConstraints) sowie zu Metainformationen und Download (https://mluk.brandenburg.de/mluk/de/service/geoinformationen/). Das Gewässernetz 25 wurde für jedes Gewässer nach seiner Lauflänge kilometriert. Die Kilometrierung erfolgte nach der Gewässerkennzahl als Schlüssel. Sie beginnt mit dem Wert 0,0 km an der Gewässermündung und steigt bis zur Quelle entsprechend der Lauflänge an. Eine Ausnahme bilden die Gewässer Oder und Westoder die nach dem System der Wasser- und Schiffahrtsverwaltung kilometriert sind. Im Darstellungsdienst Gewässernetz wird die Kilometrierung mit Hilfe maßstabsabhängiger Punktsymbole dargestellt."
    },
    
    {
      id: 'gk25',
      dct_type: 'raster',
      dct_title: 'Geologische Karte Brandenburg 1 : 25 000',
      url: 'https://inspire.brandenburg.de/services/gk_wms',
      legend_url: "https://inspire.brandenburg.de/services/gk_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=gk25&format=image/png&STYLE=default",
      layer: 'gk25',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'GeoBasis',
      metadata: "https://geoportal.brandenburg.de/gs-json/xml?fileid=26701d68-f49b-46d1-b9c4-884d15e22c49",
      geometry_type: 'raster',
      dct_catalog_publisher:"Landesvermessung und Geobasisinformation Brandenburg (LGB)",
      dct_catalog_title:"WMS Geologische Karten BB (WMS-GK)",
      dct_description: "Für ca. 80 % der Landesfläche Brandenburgs liegt die Geologischen Karte 1 : 25 000 (GK 25) vor. Diese Karte stellt die an der Oberfläche anstehenden geologischen Bildungen (Gesteine) mit einer Abbildungstiefe bis 2 m unter Gelände dar."
    },

    {
      id: 'de_basemapde_web_raster_grau_wms',
      dct_type: 'raster',
      dct_title: 'Basemap DE grau',
      url: 'https://sgx.geodatenzentrum.de/wms_basemapde',
      legend_url: "https://sgx.geodatenzentrum.de/wms_basemapde?format=image%2Fpng&layer=de_basemapde_web_raster_grau&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=",
      layer: 'de_basemapde_web_raster_grau',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      metadata: "https://mis.bkg.bund.de/csw?REQUEST=GetRecordById&SERVICE=CSW&VERSION=2.0.2&id=69264016-D304-4DD6-BCEF-509C1ED19F14",
      geometry_type: 'raster',
      dct_catalog_publisher:"Bundesamt für Kartographie und Geodäsie (BKG)",
      dct_catalog_title:"WMS DE BASEMAP.DE WEB RASTER",
      dct_description: "Der WMS DE basemap.de Web Raster hat als Datengrundlage die basemap.de Web Vektor. Die Darstellung dieser beruht auf einer bundesweit einheitlichen Definition des Webkarten-Signaturenkataloges (basemap.de Web-SK) der AdV. Es wird die basemap.de Web-SK Version in der jeweils aktuellen Fassung verwendet. Informationen zur Aktualität der Daten und zur jeweiligen Version können unter https://www.basemap.de/data/produkte/web_raster/meta/bm_web_raster_datenaktualitaet.html eingesehen werden. Der Layer enthält eine kombinierte Darstellung von ATKIS®- Landschaftsmodellen, der Hauskoordinaten und der Hausumringe, die nach basemap.de WebSK in der jeweils aktuellen Version eine Kartensignatur haben, inklusive ihrer Beschriftung."
    },


// ── ZENSUS ────────────────────────────────────────────────────────────────
// ── Bevölkerung ────────────────────────────────────────────────────────────────
{
  id: 'zensus_bevoelkerung',
  dct_type: 'raster',
  dct_title: 'Bevölkerung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=bevoelkerung_1km',
  layer: 'bevoelkerung',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Bevölkerung insgesamt laut Zensus 2022.'
},
{
  id: 'zensus_bevoelkerung_100m',
  dct_type: 'raster',
  dct_title: 'Bevölkerung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=bevoelkerung_1km',
  layer: 'bevoelkerung_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Bevölkerung am 15.05.2022, Auflösung: 100 m.'
},
{
  id: 'zensus_bevoelkerung_1km',
  dct_type: 'raster',
  dct_title: 'Bevölkerung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=bevoelkerung_1km',
  layer: 'bevoelkerung_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Bevölkerung am 15.05.2022, Auflösung: 1 km.'
},
{
  id: 'zensus_bevoelkerung_10km',
  dct_type: 'raster',
  dct_title: 'Bevölkerung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=bevoelkerung_1km',
  layer: 'bevoelkerung_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Bevölkerung am 15.05.2022, Auflösung: 10 km.'
},

// ── Ausländeranteil ───────────────────────────────────────────────────────────
{
  id: 'zensus_auslaenderanteil',
  dct_type: 'raster',
  dct_title: 'Ausländeranteil 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=auslaenderanteil_1km',
  layer: 'auslaenderanteil',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil der Ausländerinnen und Ausländer (Zensus 2022).'
},
{
  id: 'zensus_auslaenderanteil_100m',
  dct_type: 'raster',
  dct_title: 'Ausländeranteil 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=auslaenderanteil_1km',
  layer: 'auslaenderanteil_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ausländeranteil, Auflösung: 100 m.'
},
{
  id: 'zensus_auslaenderanteil_1km',
  dct_type: 'raster',
  dct_title: 'Ausländeranteil 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=auslaenderanteil_1km',
  layer: 'auslaenderanteil_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ausländeranteil, Auflösung: 1 km.'
},
{
  id: 'zensus_auslaenderanteil_10km',
  dct_type: 'raster',
  dct_title: 'Ausländeranteil 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=auslaenderanteil_1km',
  layer: 'auslaenderanteil_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ausländeranteil, Auflösung: 10 km.'
},

// ── Durchschnittsalter ────────────────────────────────────────────────────────
{
  id: 'zensus_durchschnittsalter',
  dct_type: 'raster',
  dct_title: 'Durchschnittsalter 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittsalter_1km',
  layer: 'durchschnittsalter',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittsalter der Bevölkerung (Zensus 2022).'
},
{
  id: 'zensus_durchschnittsalter_100m',
  dct_type: 'raster',
  dct_title: 'Durchschnittsalter 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittsalter_1km',
  layer: 'durchschnittsalter_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittsalter, Auflösung: 100 m.'
},
{
  id: 'zensus_durchschnittsalter_1km',
  dct_type: 'raster',
  dct_title: 'Durchschnittsalter 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittsalter_1km',
  layer: 'durchschnittsalter_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittsalter, Auflösung: 1 km.'
},
{
  id: 'zensus_durchschnittsalter_10km',
  dct_type: 'raster',
  dct_title: 'Durchschnittsalter 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittsalter_1km',
  layer: 'durchschnittsalter_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittsalter, Auflösung: 10 km.'
},

// ── Anteil unter 18 Jahren ────────────────────────────────────────────────────
{
  id: 'zensus_anteil_unter18',
  dct_type: 'raster',
  dct_title: 'Anteil unter 18 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilu18_1km',
  layer: 'anteilu18',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil der Bevölkerung unter 18 Jahren (Zensus 2022).'
},
{
  id: 'zensus_anteil_unter18_100m',
  dct_type: 'raster',
  dct_title: 'Anteil unter 18 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilu18_1km',
  layer: 'anteilu18_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Unter 18, Auflösung: 100 m.'
},
{
  id: 'zensus_anteil_unter18_1km',
  dct_type: 'raster',
  dct_title: 'Anteil unter 18 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilu18_1km',
  layer: 'anteilu18_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Unter 18, Auflösung: 1 km.'
},
{
  id: 'zensus_anteil_unter18_10km',
  dct_type: 'raster',
  dct_title: 'Anteil unter 18 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilu18_1km',
  layer: 'anteilu18_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Unter 18, Auflösung: 10 km.'
},

// ── Anteil ab 65 Jahren ───────────────────────────────────────────────────────
{
  id: 'zensus_anteil_ab65',
  dct_type: 'raster',
  dct_title: 'Anteil ab 65 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilue65_1km',
  layer: 'anteilue65',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil der Bevölkerung ab 65 Jahren (Zensus 2022).'
},
{
  id: 'zensus_anteil_ab65_100m',
  dct_type: 'raster',
  dct_title: 'Anteil ab 65 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilue65_1km',
  layer: 'anteilue65_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ab 65, Auflösung: 100 m.'
},

{
  id: 'zensus_anteil_ab65_1km',
  dct_type: 'raster',
  dct_title: 'Anteil ab 65 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilue65_1km',
  layer: 'anteilue65_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ab 65, Auflösung: 1 km.'
},
{
  id: 'zensus_anteil_ab65_10km',
  dct_type: 'raster',
  dct_title: 'Anteil ab 65 Jahren 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=anteilue65_1km',
  layer: 'anteilue65_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Ab 65, Auflösung: 10 km.'
},

// ── Nettokaltmiete (€/m²) ─────────────────────────────────────────────────────
{
  id: 'zensus_nettokaltmiete',
  dct_type: 'raster',
  dct_title: 'Nettokaltmiete (€/m²) 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittMiete_1km',
  layer: 'durchschnittMiete',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittliche Nettokaltmiete pro m².'
},
{
  id: 'zensus_nettokaltmiete_100m',
  dct_type: 'raster',
  dct_title: 'Nettokaltmiete (€/m²) 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittMiete_1km',
  layer: 'durchschnittMiete_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Nettokaltmiete, Auflösung: 100 m.'
},
{
  id: 'zensus_nettokaltmiete_1km',
  dct_type: 'raster',
  dct_title: 'Nettokaltmiete (€/m²) 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittMiete_1km',
  layer: 'durchschnittMiete_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Nettokaltmiete, Auflösung: 1 km.'
},
{
  id: 'zensus_nettokaltmiete_10km',
  dct_type: 'raster',
  dct_title: 'Nettokaltmiete (€/m²) 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=durchschnittMiete_1km',
  layer: 'durchschnittMiete_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Nettokaltmiete, Auflösung: 10 km.'
},

// ── Heizungsart (z. B. Einzel-/Zentralheizung) ────────────────────────────────
{
  id: 'zensus_heizungsart',
  dct_type: 'raster',
  dct_title: 'Heizungsart 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=heizungsarten_1km',
  layer: 'heizungsarten',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Heizungsarten von Wohnungen in Wohngebäuden.'
},
{
  id: 'zensus_heizungsart_100m',
  dct_type: 'raster',
  dct_title: 'Heizungsart 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=heizungsarten_1km',
  layer: 'heizungsarten_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Heizungsart, Auflösung: 100 m.'
},
{
  id: 'zensus_heizungsart_1km',
  dct_type: 'raster',
  dct_title: 'Heizungsart 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=heizungsarten_1km',
  layer: 'heizungsarten_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Heizungsart, Auflösung: 1 km.'
},
{
  id: 'zensus_heizungsart_10km',
  dct_type: 'raster',
  dct_title: 'Heizungsart 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=heizungsarten_1km',
  layer: 'heizungsarten_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Heizungsart, Auflösung: 10 km.'
},

// ── Energieträger der Heizung (Gas/Öl/Fernwärme/Wärmepumpe/… zusammengefasst) ──
{
  id: 'zensus_energietraeger',
  dct_type: 'raster',
  dct_title: 'Energieträger der Heizung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=energietraeger_1km',
  layer: 'energietraeger',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Energieträger der Heizung von Wohnungen in Wohngebäuden.'
},
{
  id: 'zensus_energietraeger_100m',
  dct_type: 'raster',
  dct_title: 'Energieträger der Heizung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=energietraeger_1km',
  layer: 'energietraeger_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Energieträger, Auflösung: 100 m.'
},
{
  id: 'zensus_energietraeger_1km',
  dct_type: 'raster',
  dct_title: 'Energieträger der Heizung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=energietraeger_1km',
  layer: 'energietraeger_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Energieträger, Auflösung: 1 km.'
},
{
  id: 'zensus_energietraeger_10km',
  dct_type: 'raster',
  dct_title: 'Energieträger der Heizung 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=energietraeger_1km',
  layer: 'energietraeger_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensus Zensusatlas 2022',
  dct_description: 'Energieträger, Auflösung: 10 km.'
},
// ── Leerstandsquote ───────────────────────────────────────────────────────────
{
  id: 'zensus_leerstandsquote',
  dct_type: 'raster',
  dct_title: 'Leerstandsquote 2022 in %, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=leerstandsquote_1km',
  layer: 'leerstandsquote',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil leerstehender Wohnungen (Zensus 2022).'
},
{
  id: 'zensus_leerstandsquote_100m',
  dct_type: 'raster',
  dct_title: 'Leerstandsquote 2022 in %, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=leerstandsquote_1km',
  layer: 'leerstandsquote_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Leerstandsquote, Auflösung 100 m.'
},
{
  id: 'zensus_leerstandsquote_1km',
  dct_type: 'raster',
  dct_title: 'Leerstandsquote 2022 in %, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=leerstandsquote_1km',
  layer: 'leerstandsquote_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Leerstandsquote, Auflösung 1 km.'
},
{
  id: 'zensus_leerstandsquote_10km',
  dct_type: 'raster',
  dct_title: 'Leerstandsquote 2022 in %, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=leerstandsquote_1km',
  layer: 'leerstandsquote_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Leerstandsquote, Auflösung 10 km.'
},
// ── Marktleerstandsquote ───────────────────────────────────────────────────────────
{
  id: 'zensus_marktleerstandsquote',
  dct_type: 'raster',
  dct_title: 'Marktleerstandsquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=marktleerstandsquote_1km',
  layer: 'marktleerstandsquote',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil marktaktiv leerstehender Wohnungen (Zensus 2022).'
},
{
  id: 'zensus_marktleerstandsquote_100m',
  dct_type: 'raster',
  dct_title: 'Marktleerstandsquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=marktleerstandsquote_1km',
  layer: 'marktleerstandsquote_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Marktleerstandsquote, Auflösung 100 m.'
},
{
  id: 'zensus_marktleerstandsquote_1km',
  dct_type: 'raster',
  dct_title: 'Marktleerstandsquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=marktleerstandsquote_1km',
  layer: 'marktleerstandsquote_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Marktleerstandsquote, Auflösung 1 km.'
},
{
  id: 'zensus_marktleerstandsquote_10km',
  dct_type: 'raster',
  dct_title: 'Marktleerstandsquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=marktleerstandsquote_1km',
  layer: 'marktleerstandsquote_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Marktleerstandsquote, Auflösung 10 km.'
},
// ── Eigentümerquote ───────────────────────────────────────────────────────────
{
  id: 'zensus_eigentuemerquote',
  dct_type: 'raster',
  dct_title: 'Eigentümerquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=eigentuemerquote_1km',
  layer: 'eigentuemerquote',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Anteil der Eigentümerhaushalte (Zensus 2022).'
},
{
  id: 'zensus_eigentuemerquote_100m',
  dct_type: 'raster',
  dct_title: 'Eigentümerquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=eigentuemerquote_1km',
  layer: 'eigentuemerquote_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Eigentümerquote, Auflösung 100 m.'
},
{
  id: 'zensus_eigentuemerquote_1km',
  dct_type: 'raster',
  dct_title: 'Eigentümerquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=eigentuemerquote_1km',
  layer: 'eigentuemerquote_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Eigentümerquote, Auflösung 1 km.'
},
{
  id: 'zensus_eigentuemerquote_10km',
  dct_type: 'raster',
  dct_title: 'Eigentümerquote in % 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/png&LAYER=eigentuemerquote_1km',
  layer: 'eigentuemerquote_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Eigentümerquote, Auflösung 10 km.'
},
// ── Durchschnittliche Haushaltsgröße ───────────────────────────────────────────────────────────
{
  id: 'zensus_durchschnitt_haushaltsgroesse',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Haushaltsgröße in Personen 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=durchschnittHaushaltsgroesse_1km',
  layer: 'durchschnittHaushaltsgroesse',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Mittlere Anzahl Personen pro Haushalt.'
},
{
  id: 'zensus_durchschnitt_haushaltsgroesse_100m',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Haushaltsgröße in Personen 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=durchschnittHaushaltsgroesse_1km',
  layer: 'durchschnittHaushaltsgroesse_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Mittlere Haushaltsgröße, Auflösung: 100 m.'
},
{
  id: 'zensus_durchschnitt_haushaltsgroesse_1km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Haushaltsgröße in Personen 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=durchschnittHaushaltsgroesse_1km',
  layer: 'durchschnittHaushaltsgroesse_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Mittlere Haushaltsgröße, Auflösung: 1 km.'
},
{
  id: 'zensus_durchschnitt_haushaltsgroesse_10km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Haushaltsgröße in Personen 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=durchschnittHaushaltsgroesse_1km',
  layer: 'durchschnittHaushaltsgroesse_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Mittlere Haushaltsgröße, Auflösung: 10 km.'
},
// ── Durchschnittliche Wohnfläche je Bewohner in m² ───────────────────────────────────────────────────────────
{
  id: 'zensus_wohnflaeche_bewohner',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Bewohner in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheBewohner_1km',
  layer: 'wohnflaecheBewohner',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittliche Wohnfläche pro Bewohner (m²).'
},
{
  id: 'zensus_wohnflaeche_bewohner_100m',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Bewohner in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheBewohner_1km',
  layer: 'wohnflaecheBewohner_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Bewohner, Auflösung: 100 m.'
},
{
  id: 'zensus_wohnflaeche_bewohner_1km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Bewohner in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheBewohner_1km',
  layer: 'wohnflaecheBewohner_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Bewohner, Auflösung: 1 km.'
},
{
  id: 'zensus_wohnflaeche_bewohner_10km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Bewohner in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheBewohner_1km',
  layer: 'wohnflaecheBewohner_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Bewohner, Auflösung: 10 km.'
},

// ── Durchschnittliche Wohnfläche je Wohnung in m² ───────────────────────────────────────────────────────────
{
  id: 'zensus_wohnflaeche_wohnung',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Wohnung in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheWohnung_1km',
  layer: 'wohnflaecheWohnung',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Durchschnittliche Wohnfläche pro Wohnung (m²).'
},
{
  id: 'zensus_wohnflaeche_wohnung_100m',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Wohnung in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheWohnung_1km',
  layer: 'wohnflaecheWohnung_100m',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Wohnung, Auflösung: 100 m.'
},
{
  id: 'zensus_wohnflaeche_wohnung_1km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Wohnung in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheWohnung_1km',
  layer: 'wohnflaecheWohnung_1km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Wohnung, Auflösung: 1 km.'
},
{
  id: 'zensus_wohnflaeche_wohnung_10km',
  dct_type: 'raster',
  dct_title: 'Durchschnittliche Wohnfläche je Wohnung in m² 2022, WMS Zensusatlas, gestaffelte Auflösung',
  url: 'https://www.wms.nrw.de/wms/zensusatlas',
  legend_url: 'https://www.wms.nrw.de/wms/zensusatlas?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.1.1' +
              '&FORMAT=image/png&LAYER=wohnflaecheWohnung_1km',
  layer: 'wohnflaecheWohnung_10km',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'Statistische Ämter des Bundes und der Länder (Zensus 2022)',
  metadata: 'https://www.wms.nrw.de/wms/zensusatlas?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Statistische Ämter des Bundes und der Länder',
  dct_catalog_title: 'WMS Zensusatlas 2022',
  dct_description: 'Wohnfläche je Wohnung, Auflösung: 10 km.'
},



// ── ZENSUS ────────────────────────────────────────────────────────────────



{
  id: 'urban_heat_island_wms',
  dct_type: 'raster',
  dct_title: 'Urban Heat Island Modelling (EEA / UAMV)',
  url: 'https://climate.discomap.eea.europa.eu/arcgis/services/UAMV/Urban_Heat_Island_modelling/MapServer/WMSServer/' ,
  legend_url: 'https://climate.discomap.eea.europa.eu/arcgis/services/UAMV/Urban_Heat_Island_modelling/MapServer/WMSServer?' +
              'SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0' +
              '&FORMAT=image/png&LAYER=0',
  layer: '0',  // oder eventuell „Intensity of urban heat island (°C)“ falls Name anders ist
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: 'European Environment Agency (EEA), Copernicus Climate Change Service (C3S)',
  metadata: 'https://climate.discomap.eea.europa.eu/arcgis/services/UAMV/Urban_Heat_Island_modelling/MapServer/WMSServer?SERVICE=WMS&REQUEST=GetCapabilities',
  geometry_type: 'raster',
  dct_catalog_publisher: 'EEA / UAMV (VITO)',
  dct_catalog_title: 'Urban Heat Island Modelling (100 European Städte)',
  dct_description: 'Simulierte Urban Heat Island Intensität mit 100 m Auflösung für verschiedene Städte in Europa (2008–2017).'
},

// Umweltatlas Berlin – Klimabewertungskarten 2022 (WMS)
 // ── Gesamtbewertung / Leitbahnen / Luftaustausch / Belastungen ─────────────
  {
    id: 'be_phk_luftaustausch_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Luftaustausch',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=ba_ua_phk_luftaust_2022',
    layer: 'ba_ua_phk_luftaust_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Luftaustausch 2022.'
  },
  {
    id: 'be_phk_belast_tag_gruenfreiflaechen_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Thermische Belastung am Tag (Grün-/Freiflächen)',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bb_ua_phk_belast_tag_grfrei_2022',
    layer: 'bb_ua_phk_belast_tag_grfrei_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Grün-/Freiflächen mit starker oder extremer thermischer Belastung am Tag.'
  },
  {
    id: 'be_phk_leitbahnkorridor_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Leitbahnkorridor',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bc_ua_phk_leitbahn_2022',
    layer: 'bc_ua_phk_leitbahn_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Korridore innerhalb von Kaltluftleitbahnen.'
  },
  {
    id: 'be_phk_klimarelevante_bebauung_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Wohngebiete mit klimarelevanter Funktion',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bd_ua_phk_klimarelevante_bebauung_2022',
    layer: 'bd_ua_phk_klimarelevante_bebauung_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Wohngebiete mit kühlender/positiver Funktion.'
  },
  {
    id: 'be_phk_kvsd_gruenfreiflaechen_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Hohe Kaltluftvolumenstromdichte (Grün-/Freiflächen)',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=be_ua_phk_kvsd_grfrei_2022',
    layer: 'be_ua_phk_kvsd_grfrei_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Anteile mit überdurchschnittlich hoher Kaltluftvolumenstromdichte.'
  },
  {
    id: 'be_phk_kaltlufteinwirkbereich_siedlung_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Kaltlufteinwirkbereich (Siedlungs-/Verkehrsflächen)',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bf_ua_phk_kaltluft_siedl_2022',
    layer: 'bf_ua_phk_kaltluft_siedl_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Einwirkbereich von Kaltluft in Siedlungs-/Verkehrsflächen.'
  },
  {
    id: 'be_phk_ohne_schlaffunktion_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Stadtgebiete ohne Schlaffunktion',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bg_ua_phk_oschlaf_2022',
    layer: 'bg_ua_phk_oschlaf_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Stadtgebiete mit < 10 EW/ha (keine Schlaffunktion).'
  },
  {
    id: 'be_phk_index_luftbelastung_kfz_2022',
    dct_type: 'raster',
    dct_title: 'Klimabewertung 2022 – Index der Luftbelastung durch Kfz-Verkehr',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bh_ua_phk_luftbelast_2022',
    layer: 'bh_ua_phk_luftbelast_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Index der Luftbelastung durch Kfz-Verkehr.'
  },

  // ── Bioklimatische Bewertungen (gesamt / Tag / Nacht; Siedlung & Straße) ────
  {
    id: 'be_biokl_strasse_gesamt_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Gesamtbewertung (Verkehrsflächen) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bi_ua_phk_biokl_str_2022',
    layer: 'bi_ua_phk_biokl_str_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Gesamtbewertung (Tag/Nacht) für Verkehrsflächen.'
  },
  {
    id: 'be_biokl_siedlung_gesamt_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Gesamtbewertung (Siedlungsflächen) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=bj_ua_phk_biokl_siedl_2022',
    layer: 'bj_ua_phk_biokl_siedl_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Gesamtbewertung (Tag/Nacht) für Siedlungsflächen.'
  },
  {
    id: 'be_biokl_gruenfreiflaechen_tag_2022',
    dct_type: 'raster',
    dct_title: 'Bewertung Aufenthaltsqualität am Tag (Grün-/Freiflächen, PET 14:00) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=ca_ua_phk_aufenth_grfrei_tag_2022',
    layer: 'ca_ua_phk_aufenth_grfrei_tag_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'PET-basierte Bewertung um 14:00 Uhr.'
  },
  {
    id: 'be_biokl_siedlung_tag_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Bewertung (Siedlung, PET 14:00) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=cb_ua_phk_bioklim_siedl_tag_2022',
    layer: 'cb_ua_phk_bioklim_siedl_tag_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Biokl. Bewertung Siedlung am Tag (PET 14:00).'
  },
  {
    id: 'be_biokl_strasse_tag_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Bewertung (Verkehrsflächen, PET 14:00) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=cc_ua_phk_bioklim_str_tag_2022',
    layer: 'cc_ua_phk_bioklim_str_tag_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Biokl. Bewertung Verkehrsflächen am Tag (PET 14:00).'
  },
  {
    id: 'be_ausgleich_nacht_2022',
    dct_type: 'raster',
    dct_title: 'Nächtliche Ausgleichfunktion (Grün-/Freiflächen) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=da_ua_phk_ausgleich_nacht_2022',
    layer: 'da_ua_phk_ausgleich_nacht_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Ausgleichsfunktion Grün-/Freiflächen gegenüber Siedlungsflächen (Nacht).'
  },
  {
    id: 'be_ohne_schlaffunktion_nacht_2022',
    dct_type: 'raster',
    dct_title: 'Stadtgebiete ohne Schlaffunktion (Nacht) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=db_ua_phk_oschlaf_nacht_2022',
    layer: 'db_ua_phk_oschlaf_nacht_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Stadtgebiete ohne Schlaffunktion (Nacht).'
  },
  {
    id: 'be_biokl_siedlung_nacht_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Bewertung (Siedlung, 04:00 Lufttemperatur) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=dc_ua_phk_bioklim_siedl_nacht_2022',
    layer: 'dc_ua_phk_bioklim_siedl_nacht_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Biokl. Bewertung Siedlung in der Nachtsituation.'
  },
  {
    id: 'be_biokl_strasse_nacht_2022',
    dct_type: 'raster',
    dct_title: 'Bioklimatische Bewertung (Verkehrsflächen, 04:00 Lufttemperatur) 2022',
    url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022',
    legend_url: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.3.0&FORMAT=image/png&LAYER=dd_ua_phk_bioklim_str_nacht_2022',
    layer: 'dd_ua_phk_bioklim_str_nacht_2022',
    format: 'image/png',
    crs: 'EPSG:25833',
    attribution: 'Umweltatlas Berlin / Senatsverwaltung Berlin',
    metadata: 'https://gdi.berlin.de/services/wms/ua_klimabewertung_2022?SERVICE=WMS&REQUEST=GetCapabilities',
    geometry_type: 'raster',
    dct_catalog_publisher: 'Senatsverwaltung für Stadtentwicklung, Bauen und Wohnen Berlin',
    dct_catalog_title: 'Klimabewertungskarten 2022 (Umweltatlas)',
    dct_description: 'Biokl. Bewertung Verkehrsflächen in der Nachtsituation.'
  },

  // WMS Bebauungspläne Berlin-Brandenburg (rechtswirksam / VEP / B-Plan)

  {
  id: 'bb_bebauungsplaene_rechtswirksam',
  dct_type: 'raster',
  dct_title: 'Rechtswirksame Bebauungspläne in Berlin und Brandenburg (WMS BP/VEP)',
  url: 'https://plis-bb.de/plisproject/inspire/index.php/geoserver/bebauungsplaene_wms/wms',
  layer: 'bp_rechtswirksam', // Layername lt. GetCapabilities
  format: 'image/png',
  crs: 'EPSG:3857', // unterstützt auch 25832, 31468, 31469, 4326, 3857
  transparent: true,
  tiled: true,
  attribution: '© Gemeinsame Landesplanungsabteilung Berlin-Brandenburg (GL), Quelle: LBV Brandenburg, Datenlizenz Deutschland – Namensnennung – Version 2.0 (dl-de/by-2-0)',
  legend_url:
    'https://plis-bb.de/plisproject/inspire/index.php/geoserver/bebauungsplaene_wms/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=bp_rechtswirksam',
  metadata:
    'https://plis-bb.de/plisproject/inspire/index.php/geoserver/bebauungsplaene_wms/ows?request=GetCapabilities&service=WMS',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Gemeinsame Landesplanungsabteilung Berlin-Brandenburg (GL)',
  dct_catalog_title: 'WMS Bebauungspläne Berlin-Brandenburg',
  dct_description:
    'Darstellung der Geltungsbereiche rechtswirksamer Bebauungspläne in Berlin und Brandenburg. ' +
    'Die Daten werden im Rahmen der Beteiligungen der Raumordnungsbehörde sowie zusätzlicher Recherchen des LBV Brandenburg erfasst. ' +
    'Für inhaltliche Auskünfte sind die jeweiligen Gemeinden zuständig.'
},

{
  id: 'freiburg_oekologischer_stadtplan_massnahmen',
  dct_type: 'raster',
  dct_title: 'Ökologischer Stadtplan Freiburg – Maßnahmen (WMS)',
  url: 'https://geoportal.freiburg.de/wms/uwsa_oekol_stdplan/uwsa_oekol_stdplan?',
  layer: 'oekol_stdplan', // Layername lt. GetCapabilities
  format: 'image/png',
  crs: 'EPSG:3857', // unterstützt auch 25832, 31467, 4326
  transparent: true,
  tiled: false,
  attribution:
    '© Stadt Freiburg i. Br. – Datenlizenz Deutschland – Namensnennung – Version 2.0 (Datengrundlage: Stadt Freiburg, www.freiburg.de)',
  legend_url:
    'https://geoportal.freiburg.de/wms/uwsa_oekol_stdplan/uwsa_oekol_stdplan?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=oekol_stdplan&format=image/png&STYLE=default',
  metadata:
    'https://geoportal.freiburg.de/wms/uwsa_oekol_stdplan/uwsa_oekol_stdplan?service=WMS&request=GetCapabilities&version=1.3.0',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Stadt Freiburg im Breisgau – Stabsstelle Digitales Bauen und GeoIT',
  dct_catalog_title: 'Ökologischer Stadtplan Freiburg',
  dct_description:
    'Darstellung ökologischer Maßnahmen im Stadtgebiet von Freiburg im Breisgau. ' +
    'Der Dienst stellt den Ökologischen Stadtplan der Stadt Freiburg bereit, mit Informationen zu Maßnahmen im Bereich Stadtökologie, Grünflächen und nachhaltiger Stadtentwicklung.'
},

{
  id: 'bb_bodenertrag_lw_wms',
  dct_type: 'raster',
  dct_title: 'Landwirtschaftliches Ertragspotenzial Brandenburg',
  url: 'https://inspire.brandenburg.de/services/boertrag_wms?language=ger',
  legend_url: 'https://inspire.brandenburg.de/services/boertrag_wms?map=/usr/lib/cgi-bin/map/inspire_lbgr_boertrag.map&language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=boertrag_lw&format=image/png&STYLE=default',
  layer: 'boertrag_lw',
  format: 'image/png',
  crs: 'EPSG:3857',
  attribution: '© Landesamt für Bergbau, Geologie und Rohstoffe Brandenburg (LBGR), Datenlizenz Deutschland – Namensnennung – Version 2.0 (dl-de/by-2-0)',
  metadata: 'https://geoportal.brandenburg.de/gs-json/xml?fileid=5ade3af0-d7f9-40d4-acc9-4750106c7ae4',
  geometry_type: 'raster',
  dct_catalog_publisher: 'Landesvermessung und Geobasisinformation Brandenburg (LGB)',
  dct_catalog_title: 'WMS Landwirtschaftliches Ertragspotenzial des Bodens (BOERTRAG)',
  dct_description: 'Darstellungsdienst zum geschätzten ackerbaulichen Ertragspotenzial in Brandenburg auf Basis verbreiteter Bodenformen und Bodenformengesellschaften; Legendeneinheiten weisen dominierende und subdominierende Anteile mit unterschiedlicher Schätzung des Ertragspotenzials aus.'
},

// Klimaviewer Brandenburg ––––––––––––––––––
{
  "id": "bb_klimaviewer_waermebelastungsindex_wms",
  "dct_type": "raster",
  "dct_title": "Wärmebelastungsindex (WBI)",
  "url": "https://isk.geobasis-bb.de/ows/wbi_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/wbi_wms?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=waermebelastungsindex&format=image/png&STYLE=default",
  "layer": "waermebelastungsindex",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=9d53f1a0-3a57-4c6c-ae73-c157c9b1337e",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "Wärmebelastungsindex Brandenburg",
  "dct_description": "Index für die sommerliche Wärmebelastung (WBI) für Brandenburg ergänzt um Landwirtschafts- und Gewässerflächen Brandenburg aus ATKIS"
},
{
  "id": "bb_klimaviewer_versiegelungsgrad_2021_wms",
  "dct_type": "raster",
  "dct_title": "Versiegelungsgrad 2021 Brandenburg",
  "url": "https://isk.geobasis-bb.de/ows/versiegelung_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/versiegelung_wms?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=versiegelungsgrad_2021&format=image/png&STYLE=default",
  "layer": "versiegelungsgrad_2021",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "European Union's Copernicus Land Monitoring Service information; https://doi.org/10.2909/34ef6334-d432-4041-a3da-67e156d6501d und https://doi.org/10.2909/f0bcb6f0-d775-4218-bec1-13adea01ff8f, verarbeitet durch LGB (Landesvermessung und Geobasisinformation Brandenburg), im Auftrag vom MWEKE Brandenburg; dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=dcb56712-a188-4070-801a-3649f471e86d",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Versiegelungsgrad BB",
  "dct_description": "Versiegelungsgrad für Brandenburg im Jahr 2021"
},
{
  "id": "bb_klimaviewer_versiegelungsgrad_2024_wms",
  "dct_type": "raster",
  "dct_title": "Versiegelungsgrad 2024 Brandenburg",
  "url": "https://isk.geobasis-bb.de/ows/versiegelung_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/versiegelung_wms?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=versiegelungsgrad_2024&format=image/png&STYLE=default",
  "layer": "versiegelungsgrad_2024",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "European Union's Copernicus Land Monitoring Service information; https://doi.org/10.2909/34ef6334-d432-4041-a3da-67e156d6501d und https://doi.org/10.2909/f0bcb6f0-d775-4218-bec1-13adea01ff8f, verarbeitet durch LGB (Landesvermessung und Geobasisinformation Brandenburg), im Auftrag vom MWEKE Brandenburg; dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=dcb56712-a188-4070-801a-3649f471e86d",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Versiegelungsgrad Brandenburg",
  "dct_description": "Versiegelungsgrad für Brandenburg im Jahr 2024"
},
{
  "id": "bb_klimaviewer_lufttemperatur_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Lufttemperatur 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tm_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tm_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=lufttemperatur_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "lufttemperatur_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=b8afb564-f8c7-4291-8a6c-4e52c9d84b37",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Lufttemperatur",
  "dct_description": "Projizierte Änderung von Lufttemperatur für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_lufttemperatur_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Lufttemperatur 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tm_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tm_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=lufttemperatur_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "lufttemperatur_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=b8afb564-f8c7-4291-8a6c-4e52c9d84b37",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Lufttemperatur",
  "dct_description": "Projizierte Änderung von Lufttemperatur für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_heisse_tage_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Heiße Tage 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hitzet_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hitzet_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=heisse_tage_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "heisse_tage_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=d202fef3-53a0-44c2-bd91-3a1477dd80a6",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Heiße Tage",
  "dct_description": "Projizierte Änderung von Heiße Tage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_heisse_tage_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Heiße Tage 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hitzet_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hitzet_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=heisse_tage_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "heisse_tage_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=d202fef3-53a0-44c2-bd91-3a1477dd80a6",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Heiße Tage",
  "dct_description": "Projizierte Änderung von Heiße Tage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_sommertage_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Sommertage 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-st_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-st_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=sommertage_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "sommertage_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=54000936-6294-401c-991d-31a31c033b74",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Sommertage",
  "dct_description": "Projizierte Änderung von Sommertage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_sommertage_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Sommertage 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-st_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-st_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=sommertage_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "sommertage_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=54000936-6294-401c-991d-31a31c033b74",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Sommertage",
  "dct_description": "Projizierte Änderung von Sommertage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_tropennaechte_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Tropennächte 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tn_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tn_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=tropennaechte_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "tropennaechte_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=2bf143d7-40ba-4494-9346-6cdcaf12328c",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Tropennächte",
  "dct_description": "Projizierte Änderung von Tropennächte für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_tropennaechte_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Tropennächte 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tn_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-tn_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=tropennaechte_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "tropennaechte_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=2bf143d7-40ba-4494-9346-6cdcaf12328c",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Tropennächte",
  "dct_description": "Projizierte Änderung von Tropennächte für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_dauer_von_hitzewellen_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Dauer von Hitzewellen 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hw-d_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hw-d_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=dauer_von_hitzewellen_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "dauer_von_hitzewellen_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=4e11ef33-450a-48d5-88bf-06b9ce98ab83",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Dauer von Hitzewellen",
  "dct_description": "Projizierte Änderung von Dauer von Hitzewellen für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_dauer_von_hitzewellen_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Dauer von Hitzewellen 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hw-d_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-hw-d_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=dauer_von_hitzewellen_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "dauer_von_hitzewellen_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=4e11ef33-450a-48d5-88bf-06b9ce98ab83",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Dauer von Hitzewellen",
  "dct_description": "Projizierte Änderung von Dauer von Hitzewellen für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_apfelbluetenbeginn_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Apfelblütenbeginn 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-ab_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-ab_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=apfelbluetenbeginn_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "apfelbluetenbeginn_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=55b9c3ab-7920-41f2-823b-200e27585238",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Apfelblütenbeginn",
  "dct_description": "Projizierte Änderung von Apfelblütenbeginn für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_apfelbluetenbeginn_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Apfelblütenbeginn 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-ab_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-ab_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=apfelbluetenbeginn_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "apfelbluetenbeginn_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=55b9c3ab-7920-41f2-823b-200e27585238",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Apfelblütenbeginn",
  "dct_description": "Projizierte Änderung von Apfelblütenbeginn für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_spaetfrostwahrscheinlichkeit_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Spätfrostwahrscheinlichkeit 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-sf_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-sf_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=spaetfrostwahrscheinlichkeit_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "spaetfrostwahrscheinlichkeit_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=8c414034-68fd-4a1b-9e1e-36170c2a650c",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Spätfrostwahrscheinlichkeit",
  "dct_description": "Projizierte Änderung von Spätfrostwahrscheinlichkeit für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_spaetfrostwahrscheinlichkeit_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Spätfrostwahrscheinlichkeit 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-sf_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_tas-sf_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=spaetfrostwahrscheinlichkeit_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "spaetfrostwahrscheinlichkeit_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=8c414034-68fd-4a1b-9e1e-36170c2a650c",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Spätfrostwahrscheinlichkeit",
  "dct_description": "Projizierte Änderung von Spätfrostwahrscheinlichkeit für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_niederschlagssumme_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Niederschlagssumme 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=niederschlagssumme_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "niederschlagssumme_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=52df13e2-1c14-4c8e-9499-ffbfc440b8d1",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Niederschlagssumme",
  "dct_description": "Projizierte Änderung von Niederschlagssumme für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_niederschlagssumme_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Niederschlagssumme 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=niederschlagssumme_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "niederschlagssumme_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=52df13e2-1c14-4c8e-9499-ffbfc440b8d1",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Niederschlagssumme",
  "dct_description": "Projizierte Änderung von Niederschlagssumme für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_starkniederschlagstage_groesser_30_mm_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Starkniederschlagstage >30 mm 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-snt30_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-snt30_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=starkniederschlagstage_groesser_30_mm_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "starkniederschlagstage_groesser_30_mm_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=ae777fa7-967b-45a6-8f2c-816a380ba2b1",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Starkniederschlagstage >30 mm",
  "dct_description": "Projizierte Änderung von Starkniederschlagstage >30 mm für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_starkniederschlagstage_groesser_30_mm_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Starkniederschlagstage >30 mm 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-snt30_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-snt30_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=starkniederschlagstage_groesser_30_mm_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "starkniederschlagstage_groesser_30_mm_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=ae777fa7-967b-45a6-8f2c-816a380ba2b1",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Starkniederschlagstage >30 mm",
  "dct_description": "Projizierte Änderung von Starkniederschlagstage >30 mm für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_trockentage_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Trockentage 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-tt_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-tt_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=trockentage_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "trockentage_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=2056f204-0e2d-4a90-806d-d26b8a8b5e34",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Trockentage",
  "dct_description": "Projizierte Änderung von Trockentage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_trockentage_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Trockentage 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-tt_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_pr-tt_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=trockentage_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "trockentage_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=2056f204-0e2d-4a90-806d-d26b8a8b5e34",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Trockentage",
  "dct_description": "Projizierte Änderung von Trockentage für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_potentielle_verdunstung_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Potentielle Verdunstung 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_et0_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_et0_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=potentielle_verdunstung_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "potentielle_verdunstung_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=705dade7-05ab-46e2-8528-486abab90348",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Potentielle Verdunstung",
  "dct_description": "Projizierte Änderung von Potentielle Verdunstung für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_potentielle_verdunstung_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Potentielle Verdunstung 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_et0_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_et0_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=potentielle_verdunstung_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "potentielle_verdunstung_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=705dade7-05ab-46e2-8528-486abab90348",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Potentielle Verdunstung",
  "dct_description": "Projizierte Änderung von Potentielle Verdunstung für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_klimatische_wasserbilanz_rcp85_2045_min_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Klimatische Wasserbilanz 2031-2060 (RCP8.5, Ensemble-Minimum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_et0-klimbil_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_et0-klimbil_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=klimatische_wasserbilanz_rcp85_2045_min&format=image/png&STYLE=default",
  "layer": "klimatische_wasserbilanz_rcp85_2045_min",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=ce2851df-00dd-4fd7-b675-04a229dbca1b",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Klimatische Wasserbilanz",
  "dct_description": "Projizierte Änderung von Klimatische Wasserbilanz für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Minimum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},
{
  "id": "bb_klimaviewer_klimatische_wasserbilanz_rcp85_2045_max_wms",
  "dct_type": "raster",
  "dct_title": "Änderung Klimatische Wasserbilanz 2031-2060 (RCP8.5, Ensemble-Maximum)",
  "url": "https://isk.geobasis-bb.de/ows/klimaproj_et0-klimbil_wms",
  "legend_url": "https://isk.geobasis-bb.de/ows/klimaproj_et0-klimbil_wms?language=ger&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=klimatische_wasserbilanz_rcp85_2045_max&format=image/png&STYLE=default",
  "layer": "klimatische_wasserbilanz_rcp85_2045_max",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© MWEKE Brandenburg, dl-de/by-2-0",
  "metadata": "https://geoportal.brandenburg.de/gs-json/xml?fileid=ce2851df-00dd-4fd7-b675-04a229dbca1b",
  "geometry_type": "raster",
  "dct_catalog_publisher": "Landesvermessung und Geobasisinformation Brandenburg (LGB)",
  "dct_catalog_title": "WMS Klimasignale BB - Klimatische Wasserbilanz",
  "dct_description": "Projizierte Änderung von Klimatische Wasserbilanz für 2031–2060 gegenüber 1971–2000 im Szenario RCP8.5. Maximum des ausgewählten Ensembles aus 16 regionalen Klimamodellen; dargestellt wird eine Änderung, kein absoluter Zukunftswert."
},

    // Hochwasserrisikogebiete Brandenburg
    {
      id: 'bb_hochwasserrisiko_hq_hoch_wms',
      dct_type: 'raster',
      dct_title: 'Hochwasserrisikogebiete Brandenburg – häufiges Hochwasser',
      url: 'https://maps.brandenburg.de/services/wms/hwrg',
      legend_url: 'https://maps.brandenburg.de/WMS/wasser/hwrg/legenden/hwrg_bb_hq_hoch.png',
      layer: 'Hochwasserrisikogebiete_BB_HQ-hoch',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© Landesamt für Umwelt Brandenburg, dl-de/by-2-0',
      metadata: 'https://maps.brandenburg.de/services/wms/hwrg?SERVICE=WMS&REQUEST=GetCapabilities',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Landesamt für Umwelt Brandenburg (LfU)',
      dct_catalog_title: 'Hochwasserrisikogebiete Brandenburg',
      dct_description: 'Überflutungsflächen bei einem Hochwasser mit hoher Eintrittswahrscheinlichkeit (HQ-hoch).',
    },
    {
      id: 'bb_hochwasserrisiko_hq_mittel_wms',
      dct_type: 'raster',
      dct_title: 'Hochwasserrisikogebiete Brandenburg – HQ100',
      url: 'https://maps.brandenburg.de/services/wms/hwrg',
      legend_url: 'https://maps.brandenburg.de/WMS/wasser/hwrg/legenden/hwrg_bb_hq_mittel.png',
      layer: 'Hochwasserrisikogebiete_BB_HQ-mittel',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© Landesamt für Umwelt Brandenburg, dl-de/by-2-0',
      metadata: 'https://maps.brandenburg.de/services/wms/hwrg?SERVICE=WMS&REQUEST=GetCapabilities',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Landesamt für Umwelt Brandenburg (LfU)',
      dct_catalog_title: 'Hochwasserrisikogebiete Brandenburg',
      dct_description: 'Überflutungsflächen bei einem Hochwasser mit mittlerer Eintrittswahrscheinlichkeit (HQ100, statistisch einmal in 100 Jahren).',
    },
    {
      id: 'bb_hochwasserrisiko_hq_extrem_wms',
      dct_type: 'raster',
      dct_title: 'Hochwasserrisikogebiete Brandenburg – extremes Hochwasser',
      url: 'https://maps.brandenburg.de/services/wms/hwrg',
      legend_url: 'https://maps.brandenburg.de/WMS/wasser/hwrg/legenden/hwrg_bb_hq_extrem.png',
      layer: 'Hochwasserrisikogebiete_BB_HQ-extrem',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© Landesamt für Umwelt Brandenburg, dl-de/by-2-0',
      metadata: 'https://maps.brandenburg.de/services/wms/hwrg?SERVICE=WMS&REQUEST=GetCapabilities',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Landesamt für Umwelt Brandenburg (LfU)',
      dct_catalog_title: 'Hochwasserrisikogebiete Brandenburg',
      dct_description: 'Überflutungsflächen im extremen Hochwasserszenario (HQ-extrem).',
    },

    // Rechtlich festgesetzte Überschwemmungsgebiete
    {
      id: 'bb_festgesetzte_ueberschwemmungsgebiete_wms',
      dct_type: 'raster',
      dct_title: 'Festgesetzte Überschwemmungsgebiete Brandenburg',
      url: 'https://maps.brandenburg.de/services/wms/uesg',
      legend_url: 'https://maps.brandenburg.de/WMS/wasser/uesg/legenden/uesg.png',
      layer: 'Festgesetzte_Ueberschwemmungsgebiete',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© Landesamt für Umwelt Brandenburg, dl-de/by-2-0',
      metadata: 'https://maps.brandenburg.de/services/wms/uesg?SERVICE=WMS&REQUEST=GetCapabilities',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Landesamt für Umwelt Brandenburg (LfU)',
      dct_catalog_title: 'Festgesetzte Überschwemmungsgebiete Brandenburg',
      dct_description: 'Rechtlich festgesetzte Überschwemmungsgebiete in Brandenburg.',
    },

    // BKG-Hinweiskarte Starkregengefahren – Brandenburg
    {
      id: 'bb_starkregen_tiefe_aussergewoehnlich_wms',
      dct_type: 'raster',
      dct_title: 'Starkregen Brandenburg – Überflutungstiefe, außergewöhnlich',
      url: 'https://sgx.geodatenzentrum.de/wms_starkregen',
      legend_url: 'https://sgx.geodatenzentrum.de/wms_starkregen?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image/png&LAYER=bb_tiefe_agw',
      layer: 'bb_tiefe_agw',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© BKG (2026), https://www.bkg.bund.de, dl-de/by-2-0: https://www.govdata.de/dl-de/by-2-0; Datenquellen: https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_hwk_srg.pdf',
      metadata: 'https://gdz.bkg.bund.de/index.php/default/open-data/wms-hinweiskarte-starkregengefahren-wms-starkregen.html',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      dct_catalog_title: 'Hinweiskarte Starkregengefahren',
      dct_description: 'Simulierte maximale Überflutungstiefe bei einem außergewöhnlichen, 100-jährlichen Starkregenereignis nach regionalen DWD-KOSTRA-Daten. Kanalisation und Versickerung werden nicht berücksichtigt.',
    },
    {
      id: 'bb_starkregen_tiefe_extrem_wms',
      dct_type: 'raster',
      dct_title: 'Starkregen Brandenburg – Überflutungstiefe, extrem',
      url: 'https://sgx.geodatenzentrum.de/wms_starkregen',
      legend_url: 'https://sgx.geodatenzentrum.de/wms_starkregen?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image/png&LAYER=bb_tiefe_extrem',
      layer: 'bb_tiefe_extrem',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© BKG (2026), https://www.bkg.bund.de, dl-de/by-2-0: https://www.govdata.de/dl-de/by-2-0; Datenquellen: https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_hwk_srg.pdf',
      metadata: 'https://gdz.bkg.bund.de/index.php/default/open-data/wms-hinweiskarte-starkregengefahren-wms-starkregen.html',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      dct_catalog_title: 'Hinweiskarte Starkregengefahren',
      dct_description: 'Simulierte maximale Überflutungstiefe bei einem extremen Starkregenereignis mit 100 mm Niederschlag pro Stunde. Kanalisation und Versickerung werden nicht berücksichtigt.',
    },
    {
      id: 'bb_starkregen_geschwindigkeit_aussergewoehnlich_wms',
      dct_type: 'raster',
      dct_title: 'Starkregen Brandenburg – Fließgeschwindigkeit, außergewöhnlich',
      url: 'https://sgx.geodatenzentrum.de/wms_starkregen',
      legend_url: 'https://sgx.geodatenzentrum.de/wms_starkregen?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image/png&LAYER=bb_geschw_agw',
      layer: 'bb_geschw_agw',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© BKG (2026), https://www.bkg.bund.de, dl-de/by-2-0: https://www.govdata.de/dl-de/by-2-0; Datenquellen: https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_hwk_srg.pdf',
      metadata: 'https://gdz.bkg.bund.de/index.php/default/open-data/wms-hinweiskarte-starkregengefahren-wms-starkregen.html',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      dct_catalog_title: 'Hinweiskarte Starkregengefahren',
      dct_description: 'Simulierte maximale Fließgeschwindigkeit bei einem außergewöhnlichen, 100-jährlichen Starkregenereignis nach regionalen DWD-KOSTRA-Daten. Kanalisation und Versickerung werden nicht berücksichtigt.',
    },
    {
      id: 'bb_starkregen_geschwindigkeit_extrem_wms',
      dct_type: 'raster',
      dct_title: 'Starkregen Brandenburg – Fließgeschwindigkeit, extrem',
      url: 'https://sgx.geodatenzentrum.de/wms_starkregen',
      legend_url: 'https://sgx.geodatenzentrum.de/wms_starkregen?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&FORMAT=image/png&LAYER=bb_geschw_extrem',
      layer: 'bb_geschw_extrem',
      format: 'image/png',
      crs: 'EPSG:3857',
      attribution: '© BKG (2026), https://www.bkg.bund.de, dl-de/by-2-0: https://www.govdata.de/dl-de/by-2-0; Datenquellen: https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/datenquellen_hwk_srg.pdf',
      metadata: 'https://gdz.bkg.bund.de/index.php/default/open-data/wms-hinweiskarte-starkregengefahren-wms-starkregen.html',
      geometry_type: 'raster',
      dct_catalog_publisher: 'Bundesamt für Kartographie und Geodäsie (BKG)',
      dct_catalog_title: 'Hinweiskarte Starkregengefahren',
      dct_description: 'Simulierte maximale Fließgeschwindigkeit bei einem extremen Starkregenereignis mit 100 mm Niederschlag pro Stunde. Kanalisation und Versickerung werden nicht berücksichtigt.',
    },

   // ––––– EFFIS Waldbrand WMS –––––––
    {
  "id": "effis_mf010_fwi_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Fire Weather Index (FWI) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.fwi&format=image/png&STYLE=default",
  "layer": "mf010.fwi",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_ffmc_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Fine Fuel Moisture Code (FFMC) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.ffmc&format=image/png&STYLE=default",
  "layer": "mf010.ffmc",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_dmc_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Duff Moisture Code (DMC) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.dmc&format=image/png&STYLE=default",
  "layer": "mf010.dmc",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_dc_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Drought Code (DC) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.dc&format=image/png&STYLE=default",
  "layer": "mf010.dc",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_isi_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Initial Spread Index (ISI) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.isi&format=image/png&STYLE=default",
  "layer": "mf010.isi",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_bui_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Build Up Index (BUI) (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.bui&format=image/png&STYLE=default",
  "layer": "mf010.bui",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_anomaly_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandgefahr-Anomalie (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.anomaly&format=image/png&STYLE=default",
  "layer": "mf010.anomaly",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_mf010_ranking_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandgefahr-Perzentil (Météo-France, Tageskarte)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=mf010.ranking&format=image/png&STYLE=default",
  "layer": "mf010.ranking",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Wetterbasierter Brandgefahrindex von Météo-France. Datum wird beim Laden von MOSIDI auf den aktuellen Tag gesetzt.",
  "wms_parameters": {
    "TIME": effisToday
  }
},
{
  "id": "effis_all_hs_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Feuerdetektionen alle Sensoren (letzte 7 Tage)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=all.hs&format=image/png&STYLE=default",
  "layer": "all.hs",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Satellitengestützte thermische Anomalien/Feuerdetektionen. Sie sind keine amtliche Bestätigung eines Waldbrands. Zeitraum wird beim Laden aktualisiert.",
  "wms_parameters": {
    "TIME": effisWeek
  }
},
{
  "id": "effis_viirs_hs_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Feuerdetektionen VIIRS (letzte 7 Tage)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=viirs.hs&format=image/png&STYLE=default",
  "layer": "viirs.hs",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Satellitengestützte thermische Anomalien/Feuerdetektionen. Sie sind keine amtliche Bestätigung eines Waldbrands. Zeitraum wird beim Laden aktualisiert.",
  "wms_parameters": {
    "TIME": effisWeek
  }
},
{
  "id": "effis_noaa_hs_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Feuerdetektionen NOAA (letzte 7 Tage)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=noaa.hs&format=image/png&STYLE=default",
  "layer": "noaa.hs",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Satellitengestützte thermische Anomalien/Feuerdetektionen. Sie sind keine amtliche Bestätigung eines Waldbrands. Zeitraum wird beim Laden aktualisiert.",
  "wms_parameters": {
    "TIME": effisWeek
  }
},
{
  "id": "effis_modis_hs_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Feuerdetektionen MODIS (letzte 7 Tage)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.hs&format=image/png&STYLE=default",
  "layer": "modis.hs",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "Satellitengestützte thermische Anomalien/Feuerdetektionen. Sie sind keine amtliche Bestätigung eines Waldbrands. Zeitraum wird beim Laden aktualisiert.",
  "wms_parameters": {
    "TIME": effisWeek
  }
},
{
  "id": "effis_modis_ba_poly_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) laufendes Jahr",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly&format=image/png&STYLE=default",
  "layer": "modis.ba.poly",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: laufendes Jahr. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst.",
  "wms_parameters": {
    "TIME": effisYear
  }
},
{
  "id": "effis_modis_ba_point_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) laufendes Jahr",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point&format=image/png&STYLE=default",
  "layer": "modis.ba.point",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: laufendes Jahr. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst.",
  "wms_parameters": {
    "TIME": effisYear
  }
},
{
  "id": "effis_effis_nrt_ba_poly_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) laufendes Jahr – NRT",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=effis.nrt.ba.poly&format=image/png&STYLE=default",
  "layer": "effis.nrt.ba.poly",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: laufendes Jahr – NRT. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst.",
  "wms_parameters": {
    "TIME": effisYear
  }
},
{
  "id": "effis_effis_nrt_ba_point_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) laufendes Jahr – NRT",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=effis.nrt.ba.point&format=image/png&STYLE=default",
  "layer": "effis.nrt.ba.point",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: laufendes Jahr – NRT. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst.",
  "wms_parameters": {
    "TIME": effisYear
  }
},
{
  "id": "effis_modis_ba_poly_today_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) heute",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.today&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.today",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: heute. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_today_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) heute",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.today&format=image/png&STYLE=default",
  "layer": "modis.ba.point.today",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: heute. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_week_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) letzte 7 Tage",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.week&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.week",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: letzte 7 Tage. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_week_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) letzte 7 Tage",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.week&format=image/png&STYLE=default",
  "layer": "modis.ba.point.week",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: letzte 7 Tage. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_month_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) letzte 30 Tage",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.month&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.month",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: letzte 30 Tage. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_month_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) letzte 30 Tage",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.month&format=image/png&STYLE=default",
  "layer": "modis.ba.point.month",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: letzte 30 Tage. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_season_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) laufende Saison",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.season&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.season",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: laufende Saison. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_season_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) laufende Saison",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.season&format=image/png&STYLE=default",
  "layer": "modis.ba.point.season",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: laufende Saison. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2016_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2016",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2016&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2016",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2016. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2016_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2016",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2016&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2016",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2016. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2017_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2017",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2017&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2017",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2017. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2017_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2017",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2017&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2017",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2017. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2018_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2018",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2018&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2018",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2018. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2018_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2018",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2018&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2018",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2018. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2019_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2019",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2019&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2019",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2019. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2019_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2019",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2019&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2019",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2019. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2020_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2020",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2020&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2020",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2020. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2020_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2020",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2020&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2020",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2020. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2021_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2021",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2021&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2021",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2021. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2021_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2021",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2021&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2021",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2021. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2022_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2022",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2022&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2022",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2022. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2022_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2022",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2022&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2022",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2022. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2023_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2023",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2023&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2023",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2023. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2023_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2023",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2023&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2023",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2023. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2024_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2024",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2024&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2024",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2024. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2024_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2024",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2024&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2024",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2024. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_poly_2025_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandflächen (Polygone) 2025",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.poly.2025&format=image/png&STYLE=default",
  "layer": "modis.ba.poly.2025",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandflächen (polygone). Zeitraum: 2025. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_modis_ba_point_2025_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brandorte (Punkte) 2025",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=modis.ba.point.2025&format=image/png&STYLE=default",
  "layer": "modis.ba.point.2025",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-kartierte brandorte (punkte). Zeitraum: 2025. Satellitenbasierte Kartierung; nicht alle kleinen Brände werden erfasst."
},
{
  "id": "effis_fuel_map_wms",
  "dct_type": "raster",
  "dct_title": "EFFIS – Brennmaterialkarte (Fuel Map)",
  "url": "https://maps.effis.emergency.copernicus.eu/effis",
  "legend_url": "https://maps.effis.emergency.copernicus.eu/effis?language=eng&version=1.1.1&service=WMS&request=GetLegendGraphic&layer=fuel_map&format=image/png&STYLE=default",
  "layer": "fuel_map",
  "format": "image/png",
  "crs": "EPSG:3857",
  "attribution": "© European Union, Copernicus Emergency Management Service / EFFIS; Datenquellen gemäß EFFIS; https://forest-fire.emergency.copernicus.eu/about-effis/data-license",
  "metadata": "https://maps.effis.emergency.copernicus.eu/effis?SERVICE=WMS&REQUEST=GetCapabilities",
  "geometry_type": "raster",
  "dct_catalog_publisher": "European Commission Joint Research Centre (JRC) / Copernicus EMS",
  "dct_catalog_title": "European Forest Fire Information System (EFFIS)",
  "dct_description": "EFFIS-Karte der Brennmaterialtypen als Hintergrund zur Brandgefährdung."
},
];